import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import { Typography, useTheme } from "@mui/material";
import CloseIcon from "../svgIcon/CloseIcon";

const CustomDialog = ({ open, onClose, children, titleModal, height, width }) => {
  const theme = useTheme();

  return (
    <Dialog fullWidth maxWidth="md" onClose={onClose} open={open} PaperProps={{ sx: { width: width } }}>
      <DialogTitle textAlign="center" variant="h6">
        <Typography textAlign="center" sx={{ fontSize: "24px", fontWeight: 600, textAlign: "center", border: "none" }}>
          {titleModal}
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon color={theme.palette.primary.light} />
      </IconButton>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};

export default CustomDialog;
